define.alias("shared/components/shared/ui/switcher/list", "media/components/shared/ui/switcher/list");